export { getAlphasCount, getDigitsCount, };
function getAlphasCount(value) {
    const alphas = value.match(/[a-zA-Z]/g);
    if (Array.isArray(alphas)) {
        return alphas.length;
    }
    return 0;
}
function getDigitsCount(value) {
    const digits = value.match(/\d/g);
    if (Array.isArray(digits)) {
        return digits.length;
    }
    return 0;
}
//# sourceMappingURL=commons.js.map